<template>
  <div class="text-center mb-12 mt-12">
    <h2 class="relative z-10">{{ title }}</h2>

    <p class="relative z-10">{{ info }}</p>

    <div v-if="items" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      <template v-if="items && items.length">
        <PassComponent
          v-for="pass in items"
          :key="pass.id"
          :title="pass.name"
          :img="passImage(pass)"
          :info="
            pass.information ? formatHtml(pass.information) : $t('general.pass')
          "
          :price="pass.priceLabel"
          :label="$t('pages.pass.index.buyItem', { item: pass.name })"
          @click="selectPass(pass)"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ImageUrls, Pass } from "~/types/api";
import Utils from "@/utils";
import PassComponent from "~/components/pass/elements/Pass.vue";

const { $api } = useNuxtApp();
const nuxtApp = useNuxtApp();
const router = useRouter();
const passStore = usePassStore();

interface Props {
  title?: string;
  info?: string;
  passes?: string | string[];
  images?: boolean | ImageUrls;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Title",
  info: "Info",
  passes: () => [],
  images: true,
});

const items = ref<Pass[]>([]);

onMounted(() => {
  fetchPasses();
});

const fetchPasses = async () => {
  try {
    let passes = props.passes

    if (passes && passes !== 'undefined' && typeof passes === 'string') {
      passes = passes.split(',')
    }

    const response = await $api.pass.passes()

    if (response) {
      const _items = response.passes?.filter((pass: Pass) => {
        return passes.includes(pass.id)
      })

      if (_items?.length && passes?.length) {
        _items.sort((a, b) => {
          return passes.indexOf(a.id) - passes.indexOf(b.id)
        })
      }

      items.value = _items
    }
  } catch (e) {
    // console.log(e)
  }
}

const selectPass = async (pass: Pass) => {
  passStore.setPassDetails({ pass });

  const urlQuery = passStore.urlQuery
  router.push({ path: "/pass/customer", query: urlQuery });
};

const formatHtml = (text: string) => {
  return Utils.text.formatHtml(text);
};

const passImage = (pass: Pass): string | undefined => {
  if (pass.images) {
    return pass.images.large
  } else if (nuxtApp.$site.images.pass) {
    return nuxtApp.$site.images.pass.large
  }
}
</script>
